import { FC, Fragment, useMemo } from 'react';

import { Box, Grid, Stack } from '@mui/material';
import { isEmpty } from '@npi/buddy-utils';
import { Merchant, Partner } from '@prisma/client';
import { useField } from 'formik';

import MainCard from 'src/components/MainCard/MainCard';

interface BillingInformation {
    merchant: Merchant;
    partner: Partner;
}

export const BillingInformation: FC<BillingInformation> = ({ merchant, partner }) => {
    const [{ value: invoiceTo }] = useField('invoiceTo');

    const { name, contactNumber, email, addressLines } = useMemo(() => {
        if (invoiceTo === 'PARTNER' && partner) {
            const addressLines = [
                partner?.primaryContactInformation?.pci_ra_addressLine1,
                partner?.primaryContactInformation?.pci_ra_addressLine2,
                partner?.primaryContactInformation?.pci_ra_county,
                partner?.primaryContactInformation?.pci_ra_city,
                partner?.primaryContactInformation?.pci_ra_country,
                partner?.primaryContactInformation?.pci_ra_eircode,
            ].filter((el) => {
                return !isEmpty(el);
            });

            return {
                name: `${partner?.primaryContactInformation?.pci_firstName ?? ''} ${
                    partner?.primaryContactInformation?.pci_lastName
                }`,
                email: partner?.primaryContactInformation?.pci_email,
                contactNumber: partner?.primaryContactInformation?.pci_mobilePhoneNumber,
                addressLines,
            };
        } else if (invoiceTo === 'MERCHANT' && merchant) {
            const addressLines = [
                merchant?.registeredAddress?.addressLine1,
                merchant?.registeredAddress?.addressLine2,
                merchant?.registeredAddress?.townOrCity,
                merchant?.registeredAddress?.county,
                merchant?.registeredAddress?.country,
                merchant?.registeredAddress?.eircode,
            ].filter((el) => {
                return !isEmpty(el);
            });

            return {
                name: merchant?.merchantContactName,
                addressLines,
                contactNumber: merchant?.contactNumber,
                email: merchant?.email,
            };
        }
        return {
            name: '',
            contactNumber: '',
            email: '',
            addressLines: [],
        };
    }, [merchant, partner]);

    return (
        <MainCard>
            <Stack>
                <h2 className="font-normal mb-0 mt-10">Billing Details</h2>
                <Box className="mt-30">
                    <Grid container spacing={5}>
                        <Grid item xs={6} md={6}>
                            <Box>
                                <p className="font-bold mb-0">Billing Contact</p>
                                <p className="mt-5">{name}</p>

                                <p className="font-bold mt-30 mb-0">Contact Number</p>
                                <p className="mt-5 mb-0">{contactNumber}</p>

                                <p className="font-bold mt-30 mb-0">Email</p>
                                <p className="mt-5 mb-0">{email}</p>
                            </Box>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Box>
                                <p className="font-bold mb-0">Billing Address</p>
                                <p className="mt-5">
                                    {addressLines?.map((addressLine, index) => {
                                        return (
                                            <Fragment key={index}>
                                                {addressLine} <br />
                                            </Fragment>
                                        );
                                    })}
                                </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
        </MainCard>
    );
};
